// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-bf2df272] {\n  padding: 20px;\n  padding-top: 0;\n  padding-left: 0;\n}", ""]);
// Exports
module.exports = exports;
